import { yupResolver } from "@hookform/resolvers/yup";
import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import * as yup from "yup";

import { CustomerAddressFormBlock } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.container";
import { RequiredCustomerPaymentAddressValidationSchema } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.schema";
import { parseToBPostFieldAddress } from "@/components/Form/RHF/FormFields/BPostAddressField/helpers/address.helper";
import { HiddenField } from "@/components/Form/RHF/FormFields/HiddenField/hiddenField.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { OmniFormContextProvider } from "@/utils/forms/omniForm.provider";

const EditPaymentAddressValidationSchema = yup
    .object({
        id: yup.string().required()
    })
    .concat(RequiredCustomerPaymentAddressValidationSchema);

type EditPaymentAddressFormValues = yup.InferType<
    typeof EditPaymentAddressValidationSchema
>;

type PaymentAddressFormProps = {
    address: CloudCustomerAddress;
    formId: string;
    skipValidation?: boolean;
    onFormSubmit: (
        data: CloudCustomerAddress,
        isBPostField: boolean
    ) => Promise<void>;
};

const EditPaymentAddressForm = ({
    address,
    formId,
    skipValidation = false,
    onFormSubmit
}: PaymentAddressFormProps) => {
    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            id: address.id,
            payment: parseToBPostFieldAddress(address)
        },
        resolver: yupResolver(EditPaymentAddressValidationSchema)
    });

    const onSubmit = (data: EditPaymentAddressFormValues) => {
        const customerAddress = {
            ...address,
            ...data.payment,
            box: data.payment.box || "",
            addressing: ""
        } satisfies CloudCustomerAddress;

        onFormSubmit(customerAddress, !!data.payment.selected);
    };

    return (
        <OmniFormContextProvider {...methods}>
            <form
                id={formId}
                onSubmit={methods.handleSubmit(onSubmit)}
            >
                <HiddenField<EditPaymentAddressFormValues> name="id" />
                <CustomerAddressFormBlock<
                    EditPaymentAddressFormValues,
                    AddressType.Payment
                >
                    skipValidation={skipValidation}
                    addressType={AddressType.Payment}
                    country={address.country}
                    addressStatus={
                        address.validationStatus ||
                        AddressValidationStatus.Unknown
                    }
                />
            </form>
        </OmniFormContextProvider>
    );
};

export { EditPaymentAddressForm };
